<template>
	<div>
		<!-- "installation_id": 44, "mandator_description": "Hochzillertaler Bergbahnen", "metis_id": "SKISUP-14743", "rr_available": true, "rr_missing_data_since": null, "rr_missing_data_flag": false -->
		<v-card
			tile
		>
			<v-list shaped>
				<v-subheader>{{txt.listOfInstallations}}</v-subheader>
				<v-list-item-group
					v-model="selectedItem"
					color="primary"
					:key="renderKeyLocal"
				>
				<v-list-item
					v-for="(item, i) in installationDataLocal"
					:key="i"
				>
				<v-row>
					<v-card width="100%">
						<v-list-item-content>
							<v-list-item-title><strong>{{item.mandator_description}}</strong></v-list-item-title>
							<v-col cols="12" md="2" class="colSpacing">
								<v-row>
									Message activated:
								</v-row>
								<v-row>
									<v-switch v-model="item.rr_missing_data_flag" :label="`${onOffSetter(item.rr_missing_data_flag)}`"></v-switch>
								</v-row>
							</v-col>
							<v-col cols="12" md="2" class="colSpacing">
								<v-row>
									Revenue report missing data since:
								</v-row>
								<v-row>
									<date-picker
										:date="takeDatePart(item.rr_missing_data_since)"
										:menu.sync="dateMenu"
										:itemIndex="i"
										@changeEmit="updateRevenueDate"
									/>
								</v-row>
							</v-col>
							<v-col cols="12" md="3" class="colSpacing">
								<v-row>
									Revenue report on/off:
								</v-row>
								<v-row>
									<v-switch v-model="item.rr_available" :label="`${onOffSetter(item.rr_available)}`"></v-switch>
								</v-row>
							</v-col>
							<v-col cols="12" md="2">
								<v-row>
									<v-btn outlined @click="saveChanges(i)">Save changes</v-btn>
								</v-row>
							</v-col>
							<v-col cols="12" md="2">
								<v-row>
									<alert-basic :show="buttonClickedId == i" :type="alert.type" :message="alert.message"/>
								</v-row>
							</v-col>
						</v-list-item-content>
					</v-card>
				</v-row>
				</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import DatePicker from '../../arcCustom/DatePicker.vue'
import AlertBasic from '../../vueBasics/AlertBasic.vue'

export default {
	name: 'installationRevenueDataConfig',
	components: {
		DatePicker,
		AlertBasic,
	},
	props: {
		installationData: {
			required: true,
			type: Array
		},
		renderKey: {
			required: true
		}
	},
	data(){
		return{
			renderKeyLocal: this.renderKey,
			installationDataLocal: this.installationData,
			selectedItem: '',
			dateMenu: false,
			buttonClickedId: 12345,
			txt: {
				listOfInstallations: 'List of installations',
			},
			alert: {
				message: '',
				type: 'info',
				show: false
			}
		}
	},
	watch: {
		"renderKey": {
			handler: function () {
				this.renderKeyLocal = this.renderKey
				this.installationDataLocal = this.installationData
			}
		},
		"buttonClickedId": {
			handler: function() {
				setTimeout(() => this.buttonClickedId = 12345, 6000)
			}
		}
	},
	methods: {
		takeDatePart(value){
			const format = "YYYY-MM-DD"
			if(value){
				return moment(value).format(format)
			} else {
				return moment().format(format)
			}
		},
		onOffSetter(value){
			return (value) ? 'on' : 'off'
		},
		async saveChanges(index){
			this.buttonClickedId = index
			this.installationDataLocal[index].rr_missing_data_since = moment(this.installationDataLocal[index].rr_missing_data_since).format('YYYY-MM-DD HH:mm:ss')
            
			try {
				await axios.post(config.baseAPIurl + "/admin-page/revenue-config", this.installationDataLocal[index])
				this.alert.type = 'success'
				this.alert.message = 'Changes have been saved.'
				this.alert.show = true
				this.$emit('changesMade', true)
			} catch (error) {
				this.alert.show = true
				this.alert.type = 'error'
				this.alert.message = 'Changes could not be saved.'
			}
		},
		updateRevenueDate(value, index){
            this.installationDataLocal[index].rr_missing_data_since = value
		}
	}
}
</script>

<style>
.colSpacing{
	padding-left: 25px !important;
}
</style>